import React from "react";
import "./about.scss";

import img1 from "../../../assets/about/clinic/1.JPG";
import img2 from "../../../assets/about/clinic/2.JPG";
import img3 from "../../../assets/about/clinic/4.jpg";
import img4 from "../../../assets/about/clinic/5.jpg";

const About = () => {
  return (
    <section id="about" className="ppc-about">
      <div className="about-container">

        {/* MOBILE HEADING */}
        <h2 className="about-heading">Best Dental Clinic in HSR Layout</h2>

        <div className="about-inner">
          {/* IMAGE COLLAGE */}
          <div className="about-images">
            <img src={img1} alt="Kosmix Dental Clinic" loading="lazy" />
            <img src={img2} alt="Dental Treatment" loading="lazy" />
            <img src={img3} alt="Dental Care" loading="lazy" />
            <img src={img4} alt="HSR Dental Clinic" loading="lazy" />
          </div>

          {/* CONTENT */}
          <div className="about-content">
            <h2 className="desktop-heading">
              Best Dental Clinic in HSR Layout
            </h2>

            <p>
              <strong>Kosmix Dental Clinic</strong> in HSR Layout is led by
              <strong> Dr. Shankhadeep Saha</strong>, a trusted dentist in HSR,
              supported by a skilled team dedicated to delivering personalized,
              high-quality dental care.
            </p>

            <p>
              We offer a comprehensive range of dental services including
              <strong>
                {" "}
                root canal treatments, gum care, crowns and bridges, dentures,
                dental implants, braces and aligners, smile makeovers, veneers,
                teeth whitening, and pediatric dental care.
              </strong>
            </p>

            <p>
              Our clinic is home to experienced specialists including an
              Endodontist, Periodontist, Prosthodontist, Implantologist,
              Orthodontist, Cosmetic Dentist, and Pediatric Dentist.
            </p>

            <p>
              Whether you are searching for a{" "}
              <strong>"dentist near me"</strong> or a{" "}
              <strong>"dental clinic near me"</strong>, Kosmix Dental Clinic is
              your trusted destination for advanced, pain-free dental care.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default About;
